import Vue from 'vue';
import App from './App.vue';
import router from './router.js';
import { createPinia, PiniaVuePlugin } from 'pinia';
import VueYoutube from 'vue-youtube';
import globalMixins from './mixin/globals';
import vueWsEcho from './packaging/vueWsEcho';

import SVGComponent from '@/components/common/SVGComponent';
import Title from '@/components/common/Title';
import Pagination from '@/components/common/Pagination';
import DropdownInput from '@/components/common/DropdownInput';
import TemplateLink from '@/components/common/TemplateLink';
import vClickOutside from 'v-click-outside';

import 'vue2-datepicker/locale/ko.js';
import { getThemeHost } from '@/utils/themeHost';

// 로컬에서는 로그인 화면에서 고른 사이트의 파비콘을 쓴다.
const host = getThemeHost();
  let faviconPath = '/favicon.ico'; // 기본

if (host.includes('omarket.kr')) {
    faviconPath = '/favicon.ico';

} else if (host.includes('daenlabs.kr')) {
  faviconPath = '/favicon_s.ico';
} else if (host.includes('kimmanager.co.kr')) {
  faviconPath = '/favicon_j.ico';
} else if (host.includes('connectone07.co.kr')) {
  faviconPath = '/favicon_i.ico';
} else if (host.includes('kcode.store')) {
  faviconPath = '/favicon_m.ico';
}else if (host.includes('crosssell.co.kr')) {
  faviconPath = '/favicon_c.ico';
}else if (host.includes('overlink.kr')) {
  faviconPath = '/favicon_o.ico';
}else if (host.includes('zijyasssssell.com')) {
  faviconPath = '/favicon_z.ico';
}else if (host.includes('cospia.net') || host.includes('magicone.kr')) {
  faviconPath = '/favicon_os.ico';
}else if (host.includes('smartcross.kr')) {
  faviconPath = '/favicon.ico';
}
else{
  faviconPath = '/favicon_m.ico';
}

  const favicon = document.getElementById('dynamic-favicon');
  if (favicon) {
    favicon.href = faviconPath;
  }

Vue.config.productionTip = false;
const pinia = createPinia();

Vue.component('SVGComponent', SVGComponent);
Vue.component('Title', Title);
Vue.component('Pagination', Pagination);
Vue.component('DropdownInput', DropdownInput);
Vue.component('TemplateLink', TemplateLink);



Vue.use(VueYoutube)
  .use(PiniaVuePlugin)
  .use(pinia)
  .use(globalMixins)
  .use(vClickOutside)
  .use(vueWsEcho);

new Vue({
  router: router,
  render: h => h(App),
  pinia
}).$mount('#app');
